import { gql } from '@apollo/client';
import { Navigate, useLocation, useParams } from 'react-router-dom-v5-compat';

import { useStudyRoomLinkRedirectQuery } from 'types/graphql';

/**
 * LG-366 This component will redirect away from /study-room/invites links
 *
 * - /study-room/invites/:inviteID
 * - /study-room/invites/:inviteID/:teamSlug/tracks/:trackSlug
 */
export const StudyRoomLinkRedirect = () => {
  const { inviteID = '', teamSlug } = useParams<'inviteID' | 'teamSlug'>();
  const location = useLocation();
  const { data } = useStudyRoomLinkRedirectQuery({
    variables: { inviteID },
    skip: !!teamSlug,
  });

  if (teamSlug) {
    return (
      <Navigate
        replace
        to={{
          ...location,
          // Using .replace() as there are many possible sub-paths to consider for this path
          pathname: location.pathname.replace(
            `/study-room/invites/${inviteID}/${teamSlug}`,
            `/${teamSlug}/invite/${inviteID}`,
          ),
        }}
      />
    );
  }

  if (!data) return null;

  return (
    <Navigate
      replace
      to={{
        ...location,
        pathname: `/${data?.trackInvite?.team.slug}/invite/${inviteID}`,
      }}
    />
  );
};

gql`
  query StudyRoomLinkRedirect($inviteID: String!) {
    trackInvite(inviteID: $inviteID) {
      id

      team {
        id
        slug
      }
    }
  }
`;
